module.exports = __webpack_public_path__ + "static/media/C2.dbe5c2f4.jpg";